import { theme } from "../../theme";

export const reservationView = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  listContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
    height: "100%",
  },
  topFilters: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  searchForm: {
    padding: "0px 10px",
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 5%)",
    border: "1px solid #E7E7E7",
    borderRadius: "6px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: 0,
  },
  searchInput: {
    flex: 1,
    border: 0,
    boxShadow: "none",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    "&.MuiFormControl-root": {
      m: 0,
    },
    "& .MuiInputBase-root": {
      padding: "9px 10px 9px 10px",
      borderTopRightRadius: "0 !important",
      borderBottomRightRadius: "0 !important",
    },
  },
  searchButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: "5px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: "5px",
  },
  clearIcon: {
    cursor: "pointer",
  },
  descriptionBox: {
    width: '100%', border: "1px solid #E7E7E7",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px",
    background: "#fff",
    color: "#787878",
    padding: "12px 10px"
  },
  descriptionBoxInner: { maxHeight: "140px", height: "100%", overflow: "auto" },
  tabSection: { overflow: "auto", display: "flex", flexDirection: "column", "& .MuiTabPanel-root": { p: 0, overflow: "auto", display: 'flex', flexDirection: "column", } },
  loadingStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 302px)",
    width: "100%",
    "& > div":{
      m:0,
      height:'auto',
    }
  },
  groupIcon:{
    position: "relative",
    top: "3px",
    marginRight: "7px",
    color: theme.palette.text.primary,
    fontSize: "18px",
  },
  subtitleStyle:{ lineHeight: 1, fontSize: "14px", color: "#787878",margin:"10px 0" }
} as const;

